export function getSafeRedirectPath(
  redirectTo: null | string | undefined,
  fallbackPath: string,
): string {
  if (!redirectTo?.startsWith('/') || redirectTo.startsWith('//')) return fallbackPath

  try {
    const origin = 'https://auth.invalid'
    const destination = new URL(redirectTo, origin)

    if (destination.origin === origin && !destination.pathname.startsWith('//')) {
      return `${destination.pathname}${destination.search}${destination.hash}`
    }
  } catch {
    return fallbackPath
  }

  return fallbackPath
}
